module.exports = __webpack_public_path__ + "media/videopurple.b341c5b4.mp4";